import { getParamsOfUrl, getUrl } from '../mixins/search';
import { getOrderParams } from '../mixins/property-list';
import { addQueryArgs } from '@wordpress/url';
import { addMarker, closePopup, getMapBounds, openPopup } from '../../mixins/map';
import L from 'leaflet';

let headerMapNode, mapAreaNode, propertyAreaNode, sortNode, containerNode;
let map;
const restNamespace = REALPRESS_GLOBAL_OBJECT.rest_namespace || '';
let query = { offset: 1, orderby: 'date', order: 'DESC', has_coordinates: true, template: 'header_map', posts_per_page: 10 };
const realpressHeaderMap = () => {
	headerMapNode = document.querySelector( '#realpress-header-map' );
	if ( ! headerMapNode ) {
		return;
	}

	mapAreaNode = headerMapNode.querySelector( '.realpress-hm-map-area' );
	propertyAreaNode = headerMapNode.querySelector( '#realpress-hm-property-area' );
	sortNode = headerMapNode.querySelector( '.realpress-sort-by' );
	containerNode = headerMapNode.querySelector( '.realpress-property-container' );

	const queryParams = getParamsOfUrl();
	if ( Object.keys( queryParams ).length ) {
		query = { ...query, ...queryParams };
	}
	sort();

	getProperties( query );
};

const sort = () => {
	sortNode.addEventListener( 'change', function( event ) {
		const paginationNode = headerMapNode.querySelector( '.realpress-hm-pagination .realpress-pagination' );
		let offset = 1;
		if ( paginationNode ) {
			offset = paginationNode.querySelector( 'li.current a' ).getAttribute( 'data-page' );
		}
		const selected = event.target.value;
		const sortParams = getOrderParams( selected );
		query = { ...query, ...sortParams, offset };
		getProperties( query );
		propertyAreaNode.scrollIntoView( { behavior: 'smooth' } );
	} );
};

const getProperties = () => {
	containerNode.style.opacity = 0.4;
	wp.apiFetch( {
		path: addQueryArgs( '/' + restNamespace + '/property-list', query ),
		method: 'GET',
	} ).then( ( res ) => {
		if ( res.data.content !== undefined ) {
			containerNode.innerHTML = res.data.content;
		} else if ( res.msg ) {
			containerNode.innerHTML = res.msg;
		}

		if ( res.data.property === undefined ) {
			handlePropertyMap( [] );
		} else {
			handlePropertyMap( res.data.property );
		}

		if ( res.data.pagination !== undefined ) {
			headerMapNode.querySelector( '.realpress-hm-pagination' ).innerHTML = res.data.pagination;
		} else {
			headerMapNode.querySelector( '.realpress-hm-pagination' ).innerHTML = '';
		}

		if ( res.data.from_to !== undefined ) {
			headerMapNode.querySelector( '.realpress-hm-from-to' ).innerHTML = res.data.from_to;
		} else {
			headerMapNode.querySelector( '.realpress-hm-from-to' ).innerHTML = '';
		}

		const paginationNode = headerMapNode.querySelector( '.realpress-pagination' );
		if ( !! paginationNode ) {
			const pageNodes = paginationNode.querySelectorAll( 'a' );
			for ( let i = 0; i < pageNodes.length; i++ ) {
				pageNodes[ i ].addEventListener( 'click', function( event ) {
					event.preventDefault();
					const offset = this.getAttribute( 'data-page' );
					query = { ...query, offset };
					getProperties( query );
					propertyAreaNode.scrollIntoView( { behavior: 'smooth' } );
				} );
			}
		}
	} ).catch( ( err ) => {
		console.log( err );
	} ).finally( () => {
		const urlPush = getUrl( query );
		window.history.pushState( '', '', urlPush );
		containerNode.style.opacity = 1;
	} );
};

const handlePropertyMap = ( properties ) => {
	const tileLayer = L.tileLayer( 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
		attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
	} );

	const mapBounds = getMapBounds( properties );
	let mapCenter = null;
	if ( mapBounds.length === 1 ) {
		mapCenter = L.latLng( mapBounds[ 0 ] );
	}

	const mapOptions = {
		dragging: true,
		center: mapCenter,
		zoom: 10,
		scrollWheelZoom: false,
		tap: false,
	};

	if ( map !== undefined ) {
		map.remove();
	}

	map = L.map( 'realpress-hm-map-area', mapOptions );
	map.addLayer( tileLayer );
	if ( 1 < mapBounds.length ) {
		map.fitBounds( mapBounds );
	}
	addMarker( properties, map );
};

const triggerPopup = () => {
	const propertyItemNodes = containerNode.querySelectorAll( '.realpress-property-item' );
	if ( ! propertyItemNodes ) {
		return;
	}
	for ( let i = 0; i < propertyItemNodes.length; i++ ) {
		const propertyItemNode = propertyItemNodes[ i ];
		const propertyId = propertyItemNode.getAttribute( 'property-id' );

		propertyItemNode.addEventListener( 'mouseenter', function() {
			openPopup( map, propertyId );
		} );
		propertyItemNode.addEventListener( 'mouseleave', function() {
			closePopup( map, propertyId );
		} );
	}
};

export default realpressHeaderMap;
